import React from 'react';

import { Button as ChakraButton } from '@chakra-ui/react';
import styled from '@emotion/styled';

const getBaseButtonStyles = (theme, props) => ({
  padding: '0',
  width: '35px',
  height: '25px',
  minWidth: '20px',
  borderRadius: '50%',
  border: `1px solid ${theme.colors.neutral.CFD7DF}`,
  borderRight: 'none',
  '& svg': {
    color: theme.colors.icon['1565BC'],
  },

  '& .chakra-button__icon': {
    margin: '0px',
  },
  '&:hover:enabled': {
    cursor: 'pointer',
    backgroundColor: theme.colors.circularButton.blue.hover,
    '& svg': {
      color: theme.colors.icon.white,
    },
  },

  '&:active:enabled, &.active-styles': {
    backgroundColor: theme.colors.circularButton.blue.focus,
    '& svg': {
      color: theme.colors.icon.white,
    },
  },
});

const StyledButton = styled(ChakraButton)(({ theme, ...props }) => ({
  ...getBaseButtonStyles(theme, props),
  backgroundColor: theme.colors.circularButton.blue.default,
  '&:hover:disabled': {
    backgroundColor: theme.colors.circularButton.blue.disabled,
  },
}));

export const CircularButton = ({
  children,

  StartIcon,

  ...props
}) => {
  let StartIconComp;

  if (StartIcon) {
    StartIconComp = <StartIcon color="circularButton.blue.hover" boxSize="20px" />;
  }

  return <StyledButton {...props} leftIcon={StartIconComp} />;
};
